var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12L11 14.5L15 9.5C15.2 9.3 15.5 9.3 15.7 9.5C15.9 9.7 15.9 10 15.7 10.2L11.5 15.5C11.3 15.7 11 15.7 10.8 15.5L8.2 12.5C8 12.3 8 12 8.2 11.8C8.4 11.6 8.7 11.6 9 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C12.2 1.5 12.5 1.5 12.7 1.6L18.8 3.9C19.8 4.3 20.4 4.6 20.8 5C21.2 5.4 21.5 5.9 21.6 6.3C21.8 6.9 21.8 7.4 21.8 7.8V12C21.8 17.2 15.2 21.2 13.1 22.3C12.7 22.5 12.4 22.6 12 22.7C11.6 22.6 11.3 22.5 10.9 22.3C8.8 21.2 2.2 17.2 2.2 12V7.8C2.2 7.4 2.2 6.9 2.4 6.3C2.5 5.9 2.8 5.4 3.2 5C3.6 4.6 4.2 4.3 5.2 3.9L11.3 1.6C11.5 1.5 11.8 1.5 12 1.5ZM12 3C11.9 3 11.7 3 11.5 3.1L5.4 5.4C4.7 5.7 4.3 5.9 4.1 6.2C3.9 6.4 3.7 6.7 3.6 7C3.5 7.3 3.5 7.6 3.5 7.8V12C3.5 16.5 9.5 20.2 11.5 21.3C11.7 21.4 11.8 21.4 12 21.4C12.2 21.4 12.3 21.4 12.5 21.3C14.5 20.2 20.5 16.5 20.5 12V7.8C20.5 7.6 20.5 7.3 20.4 7C20.3 6.7 20.1 6.4 19.9 6.2C19.7 5.9 19.3 5.7 18.6 5.4L12.5 3.1C12.3 3 12.1 3 12 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.29a9a667747ee011adca16eaf5083951.svg";
export { ForwardRef as ReactComponent };